import { useMutation } from 'react-query';
import queries from '../queries';

/**
 * Hook to register account with company selection
 */
export const useRegisterAccount = (callbacks = {}) => {
  return useMutation((data) => queries.enterprise.registerWithCompany.query(data), {
    ...callbacks,
    onSuccess: (response, variables) => {
      if (typeof callbacks.onSuccess === 'function') {
        callbacks.onSuccess(response.data, variables);
      }
    },
    onError: (error) => {
      if (typeof callbacks.onError === 'function') {
        callbacks.onError(error);
      }
    },
  });
};

export default {
  useRegisterAccount,
};
